export const BILLING_ACCESS = 'Billing';
export const UserRoleInfoLink = 'https://docs.qualio.com/en/articles/6526420-user-permissions#h_05f8de8e68';
export const UserPermissionsInfoLink = 'https://docs.qualio.com/en/articles/6526420-user-permissions#h_221c4fdef8';
